import DragonDrop from 'drag-on-drop';

function initialize($gridView) {
  const $container = $gridView.find('table tbody').get(0);
  const endpoint = $gridView.data('sortableAction') || window.location.href;
  const associative = $gridView.data('sortableAssociative') === true;

  const dragonDrop = new DragonDrop($container, {
    item: 'tr',
    handle: '.sortable__handle',
    activeClass: 'sortable__item--active',
    inactiveClass: 'sortable__item--inactive',
    announcement: {
      grabbed(el, items) {
        return `Item ${items.indexOf(el) + 1} grabbed`;
      },
      dropped(el, items) {
        return `Item ${items.indexOf(el) + 1} dropped`;
      },
      reorder(el, items) {
        return `The list has been reordered, The item is now on ${items.indexOf(el) + 1} of ${items.length}`;
      },
    },
  });

  function updateReorder(items) {
    const gridContainer = $('[data-sortable-grid-view]').closest('[data-pjax-container]');
    gridContainer.addClass('pjax--loading').attr('aria-busy', 'true');

    const originalIndexes = items.map((element, index) => (associative
      ? parseInt(element.querySelector('[data-td-title="#"]').textContent, 10)
      : index));
    const startingIndex = originalIndexes.length > 0 ? Math.min(...originalIndexes) : 0;
    const orderedItems = items.reduce((associativeObject, element, index) => {
      // eslint-disable-next-line no-param-reassign
      associativeObject[index + startingIndex] = element.dataset.key;
      return associativeObject;
    }, {});

    $.post(endpoint, { order: orderedItems }).done(() => {
      if (associative) {
        items.forEach((element, arrayIndex) => {
          if (element.querySelector('[data-td-title="#"]')) {
            // eslint-disable-next-line no-param-reassign
            element.querySelector('[data-td-title="#"]').textContent = startingIndex + arrayIndex;
          }
        });
      }
      gridContainer.removeClass('pjax--loading').attr('aria-busy', 'false');
    });
  }

  function listener(e) {
    e.preventDefault();
  }

  dragonDrop.dragula.on('drag', () => {
    document.addEventListener('touchmove', listener, { passive: false });
  });

  dragonDrop.dragula.on('dragend', () => {
    document.removeEventListener('touchmove', listener, { passive: false });
  });

  dragonDrop.dragula.on('drop', () => {
    updateReorder(dragonDrop.items);
  });
}

export default function sortableGridView() {
  $('[data-pjax-container]').on('pjax:end', (event) => {
    $('[data-sortable-grid-view]', $(event.currentTarget)).each((index, element) => {
      initialize($(element));
      const sortedHeader = $('[aria-sort="ascending"] a, [aria-sort="descending"] a', $(element));
      sortedHeader.focus();
    });
  });
  $('[data-sortable-grid-view]').each((index, element) => {
    initialize($(element));
  });
}
